module.exports = __webpack_public_path__ + "static/media/Mereoleona-Script.b74d6134.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Mereoleona-Script.ttf
// module id = 2307
// module chunks = 43